<template>
    <div class="custom-actions">
        <label class="filter-label"> {{label_parent}}: </label>
        <select class="form-control" v-model="parent_id" @change="passEventToGetChild($event)" :name="this.name_parent" required>
            <option value="null">---</option>
            <option v-for="(row) in parent_list"  :value="row.id">
                {{ row.name }}
            </option>
        </select>

        &nbsp;<label class="filter-label"> {{label_children}}: </label>
        <select class="form-control" v-model="child_id" :name="name_children" required @change="passEventToGetGrandson($event)">
            <option v-for="(row) in children_list" :value="row.id">
                {{ row.name }}
            </option>
        </select>

        &nbsp;<label class="filter-label"> {{label_grandson}}: </label>
        <select class="form-control" v-model="grandson_id" :name="name_grandson" required>
            <option v-for="(row) in grandson_list" :value="row.id">
                {{ row.name }}
            </option>
        </select>



    </div>
  </template>

<script>
    export default {

        mounted() {

            console.log(this.parent_key);
            console.log(this.child_key);

            //setup parent_list and default values
            this.parent_id = this.parent_id_default;
            //console.log("MOUNT ",this.parent_id,this.parent_list);

            if(this.child_id_default !== "0"){

                //case edit, populate the child_list and set default child
                this.child_id = this.child_id_default;
                this.getChild(this.child_id);

                if(this.grandson_id_default !== "0"){
                  this.grandson_id = this.grandson_id_default;
                  this.getGrandsons(this.grandson_id)
                }
            }
        },
        props: {
            parent_list: {
                type: Array,
                required: true
            },
            parent_id_default: {
                type: [String,Number],
                required: false,
                default : null
            },
            child_id_default: {
                type: Number,
                required: false,
                default : null
            },
            grandson_id_default: {
                type: Number,
                required: false,
                default : null
            },
            label_children: {
                type: String,
                required: true
            },
            label_grandson: {
                type: String,
                required: true
            },
            label_parent: {
                type: String,
                required: true
            },
            name_grandson: {
                type: String,
                required: true
            },
            name_children: {
                type: String,
                required: true
            },
            name_parent: {
                type: String,
                required: false,
                default : ""
            },
            parent_key: {
                type: String,
                required: true
            },
            child_key: {
                type: String,
                required: true
            },
            child_model:{
                type: String,
                required: true
            },
            parent_model:{
                type: String,
                required: true
            },
            end_point:{
                type:String,
                required:false,
                default : "default"
            }


        },
        data()  {
            return {
                parent_id : null,
                child_id : null,
                grandson_id : null,
                children_list : [],
                grandson_list : [],
            }
        },
        methods: {

          passEventToGetGrandson(event){
            this.getGrandsons(event.target.value);
            },
            passEventToGetChild(event){
                this.getChild(event.target.value);
            },

          getGrandsons(id){

                let url = "/get-children-of-parent/"+this.child_id+"/parent_id/"+this.child_key+"/parent_key/"+escape(this.child_model)+"/model";
                let params = {};
                if(this.end_point !== "default"){
                    url = this.end_point
                    params["parent_id"] =this.child_id;
                }

                axios.get(url,{params : params})
                    .then((response) => {
                        this.grandson_list = response.data;
                    });
            },
            getChild(id){

                let url = "/get-children-of-parent/"+this.parent_id+"/parent_id/"+this.parent_key+"/parent_key/"+escape(this.parent_model)+"/model";
                let params = {};
                if(this.end_point !== "default"){
                    url = this.end_point
                    params["parent_id"] =this.parent_id;
                }

                axios.get(url,{params : params})
                    .then((response) => {
                        console.log(response.data);
                        this.children_list = response.data;
                    });
            },



        }
    }
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
.compensation-filter {
width:160px;
font-size:14px
}
.filter-label {
color:#1767A2;
font-size:14px;
}
</style>
